import useIsClient from "@core-ui/hooks/useIsClient";
import isNavigatorAvailable from "@core-ui/isNavigatorAvailable";
import { tryCopyToClipboard } from "@core-ui/utils/clipboard";
import t from "@ext/localization/locale/translate";
import { Button } from "@ui-kit/Button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import { useState } from "react";

export const CodeBlockCopyButton = ({ text }: { text: string }) => {
	const [copied, setCopied] = useState(false);
	// A server has no clipboard, so the page hydrates without the button and gets it right after.
	const isClient = useIsClient();
	if (!isClient || !isNavigatorAvailable()) return null;
	const label = copied ? t("copied") : t("click-to-copy");
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button
					aria-label={label}
					className="h-[2em] w-[2em] p-0 absolute right-2 top-2 z-10 opacity-0 group-hover/code:opacity-100 focus-visible:opacity-100 bg-background"
					contentEditable={false}
					onClick={() => {
						void tryCopyToClipboard(text, { showPopover: false }).then((success) => setCopied(success));
					}}
					onMouseLeave={() => setCopied(false)}
					size="sm"
					startIcon={copied ? "check" : "copy"}
					type="button"
					variant="ghost"
				/>
			</TooltipTrigger>
			<TooltipContent>{label}</TooltipContent>
		</Tooltip>
	);
};
